/**
 * The drop door's membership write. The handshake door opts in server-side;
 * the email door must call this on login success or the member never reaches
 * the registry. Idempotent upsert — safe to fire-and-forget.
 */
import {useMutation} from "@tanstack/react-query";
import {useSelector} from "react-redux";
import {DropsApi} from "@devour/client";
import getConfig from "@/utils/getConfig";
import {IStore} from "@/redux/defaultStore";

export interface DropOptInVars {
    slug: string;
    declaredCountry?: string;
    declaredState?: string;
    /* The version the member just accepted; the server refuses a mismatch. */
    termsVersion?: string;
}

export function useCreateDropOptIn() {
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);

    return useMutation({
        mutationFn: async ({slug, declaredCountry, declaredState, termsVersion}: DropOptInVars) => {
            const api = new DropsApi(getConfig(fullToken));
            return await api.createDropsSlugOptIn({
                slug,
                dropOptInBody: {
                    declaredCountry,
                    declaredState,
                    termsVersion,
                },
            });
        },
    });
}
